import { render, staticRenderFns } from "./ParametrizacaoAcaoPasso4ColunaComplementoInformacoes.vue?vue&type=template&id=162546f6"
import script from "./ParametrizacaoAcaoPasso4ColunaComplementoInformacoes.vue?vue&type=script&lang=js"
export * from "./ParametrizacaoAcaoPasso4ColunaComplementoInformacoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports